import React from "react";
import { BiHome } from "react-icons/bi";
import { BsClipboardCheck } from "react-icons/bs";
import { CgAddR } from "react-icons/cg";
import { HiOutlineLocationMarker } from "react-icons/hi";
import { Link, useLocation } from "react-router-dom";
import { AiOutlineUser } from "react-icons/ai";
const Tab = () => {
  const tab = [
    { id: 1, title: "خانه", icon: <BiHome />, to: "/" },
    { id: 2, title: "دسته ها", icon: <BsClipboardCheck />, to: "/categories" },
    {
      id: 3,
      title: "ثبت اگهی",
      icon: <CgAddR />,
      selected: true,
      to: "/submit-ads",
    },
    { id: 4, title: "شهر", icon: <HiOutlineLocationMarker />, to: "/cities" },
    { id: 5, title: "پروفایل", icon: <AiOutlineUser />, to: "/profile" },
  ];
  const { pathname } = useLocation();
  // console.log("pathname", pathname);
  return (
    <div className="tabBar">
      {tab.map((item) => {
        if (item.selected)
          return (
            <Link className="tab ads-tab" {...item}>
              <div className="tab-icon">{item.icon}</div>
              <p className="tab-text  fs-10"> {item.title}</p>
            </Link>
          );
        else
          return (
            <Link className="tab" data-active={pathname == item.to} {...item}>
              <div className="tab-icon">{item.icon}</div>
              <p className="tab-text  fs-10">{item.title}</p>
            </Link>
          );
      })}
    </div>
  );
};

export default Tab;
